import React from "react"
import Row from "./Row"

export default function Fixture({ fixture }) {
  const {
    columnCount = 1,
    rowWidth = 160,
    isCooler = false,
    isSelected = false,
    isSingleCooler = false,
    gondolaType = "",
    head = [],
    foot = [],
    rows = [],
  } = fixture || {}

  const width = isSingleCooler || columnCount === 1 ? rowWidth || 130 : rowWidth || 200
  const className = [
    "fixture",
    head.length > 0 ? "" : isCooler ? "no-head-c" : "no-head-g",
    foot.length > 0 ? "" : isCooler ? "no-foot-c" : "no-foot-g",
    isCooler ? "cooler" : "gondola",
    isSelected ? "selected" : "",
  ]
    .filter(Boolean)
    .join(" ")

  return (
    <div className={className} style={{ width }}>
      {head?.length > 0 ? (
        <Row
          row={{ column: head }}
          columnCount={columnCount}
          section="head"
          centered={columnCount === 1}
          gondolaType={gondolaType}
        />
      ) : (
        <div className="cls-gradient-row" />
      )}

      {rows.map((row) => (
        <>
          <Row
            key={row.rowIndex}
            row={row}
            columnCount={columnCount}
            section="body"
            centered={columnCount === 1}
            gondolaType={gondolaType}
          />
          <div
            className="cls-gradient-row"
            // style={{ width: "100%", height: 4, backgroundColor: "pink" }}
          />
        </>
      ))}

      {foot?.length > 0 ? (
        <Row
          row={{ column: foot }}
          columnCount={columnCount}
          section="foot"
          centered={columnCount === 1}
          gondolaType={gondolaType}
        />
      ) : null}
    </div>
  )
}
